import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import Section from '../Section';
import AboutSectionStyle2 from '../Section/AboutSection/AboutSectionStyle2';
import FeaturesSectionStyle2 from '../Section/FeaturesSection/FeaturesSectionStyle2';
import FunFactSection from '../Section/FunFactSection';
import TeamSection from '../Section/TeamSection';
import GallerySection from '../Section/GallerySection';
import AwardSectionStyle2 from '../Section/AwardSection/AwardSectionStyle2';
import { pageTitle } from '../../helpers/PageTitle';

const featureListData = [
  {
    title: 'Expertise cardiologique',
    subTitle:
      'Une prise en charge spécialisée, fondée sur l’expérience du Dr El ISSA et de son équipe.',
    iconUrl: 'images/icons/professional.svg',
  },
  {
    title: 'Formation France & Suisse',
    subTitle:
      'Double cursus, cardiologie du sport, imagerie multimodale et médecine d’urgence.',
    iconUrl: 'images/icons/comprehensive.svg',
  },
  {
    title: 'HTA, écho et effort',
    subTitle:
      'Hypertension artérielle, échocardiographie et épreuves d’effort au cœur de notre pratique.',
    iconUrl: 'images/icons/patient.svg',
  },
  {
    title: 'Accueil au XVIᵉ',
    subTitle:
      'Un institut à Paris 16ᵉ, disponible, bienveillant et professionnel, pour un suivi personnalisé.',
    iconUrl: 'images/icons/facilities.svg',
  },
];

const funFactData = [
  { number: '16ᵉ', title: 'Arrondissement de Paris' },
  { number: '2', title: 'Langues parlées (FR / EN)' },
  { number: '6+', title: 'Examens cardiovasculaires sur place' },
  { number: '6j', title: 'Ouverture lundi – samedi' },
  { number: '100%', title: 'Nouveaux patients acceptés' },
];

const placeholder = 'images/about/team_placeholder.svg';
const teamData = [
  {
    imgUrl: '/images/about/doc-issa-placeholder.png',
    name: 'Dr El Issa Meidi',
    designation: 'Cardiologue',
    description:
      'Maladies cardiovasculaires, imagerie cardiaque multimodale, cardiologie du sport et médecine d’urgence.',
  },
  {
    imgUrl: placeholder,
    name: 'Tiffany',
    designation: 'Responsable du cabinet',
  },
  {
    imgUrl: placeholder,
    name: 'Nassima',
    designation: 'Infirmière',
  },
  {
    imgUrl: placeholder,
    name: 'Tara',
    designation: 'Assistante médicale',
  },
  {
    imgUrl: placeholder,
    name: 'Sylvia',
    designation: 'Assistante médicale',
  },
  {
    imgUrl: placeholder,
    name: 'Marie Henriette',
    designation: 'Assistante médicale en apprentissage',
  },
  {
    imgUrl: placeholder,
    name: 'Fanta',
    designation: 'Assistante médicale en apprentissage',
  },
  {
    imgUrl: placeholder,
    name: 'Aarthy',
    designation: 'Assistante médicale en apprentissage',
  },
  {
    imgUrl: placeholder,
    name: 'À pourvoir',
    designation: 'Assistante médicale en apprentissage',
    description: 'Poste bientôt pourvu.',
  },
  {
    imgUrl: placeholder,
    name: 'À pourvoir',
    designation: 'Assistante médicale en apprentissage',
    description: 'Poste bientôt pourvu.',
  },
];

const galleryData = [
  { imgUrl: '/images/about/portfolio_2_lg.jpeg' },
  { imgUrl: '/images/about/portfolio_3_lg.jpeg' },
  { imgUrl: '/images/about/portfolio_1_lg.jpeg' },
  { imgUrl: '/images/about/portfolio_4_lg.jpeg' },
  { imgUrl: '/images/about/portfolio_5_lg.jpeg' },
];
const awardData = [
  {
    iconUrl: '/images/icons/award.svg',
    title: 'Engagement pour l’excellence des soins',
  },
  { iconUrl: '/images/icons/award.svg', title: 'Imagerie cardiaque multimodale' },
  {
    iconUrl: '/images/icons/award.svg',
    title: 'Prévention et suivi personnalisé',
  },
  {
    iconUrl: '/images/icons/award.svg',
    title: 'Accueil des patients internationaux',
  },
];

export default function About() {
  pageTitle('À propos');
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/about/banner_img.png"
        title="À propos de <br />l’ICVT"
        subTitle="Votre santé cardiovasculaire est au cœur de notre engagement."
      />
      <Section topMd={200} topLg={150} topXl={110}>
        <AboutSectionStyle2
          title="Dr El ISSA"
          imgUrl="/images/about/docteur-issa.png"
          subTitle={`<p>Votre santé cardiovasculaire est au cœur de notre engagement. L’ICVT vous propose une prise en charge spécialisée, fondée sur l’expertise du Dr El ISSA, cardiologue, et de son équipe de professionnels de santé qualifiés.</p>
<p>Le Dr El ISSA est spécialisé dans les maladies cardiovasculaires et bénéficie d’une double formation en France et en Suisse. Après s’être spécialisé en cardiologie du sport, il a développé une expertise approfondie en imagerie cardiaque multimodale ainsi qu’en médecine d’urgence.</p>
<p>Son domaine d’expertise comprend notamment la prise en charge de l’hypertension artérielle, l’échocardiographie et les épreuves d’effort.</p>
<p>Récemment installé dans le XVIᵉ arrondissement de Paris, le Dr El ISSA a ouvert, avec son équipe, l’ICVT, un institut qui vous accueille avec disponibilité, bienveillance et professionnalisme, afin de vous offrir une prise en charge personnalisée et de qualité.</p>`}
        />
      </Section>
      <Section topMd={175} topLg={125} topXl={85} bottomMd={100} bottomLg={110}>
        <FeaturesSectionStyle2
          sectionTitle="Pourquoi nous choisir"
          imgUrl="images/about/why_choose_us.jpeg"
          data={featureListData}
        />
      </Section>
      <Section>
        <FunFactSection
          bgUrl="images/about/fun_fact_bg.jpeg"
          data={funFactData}
        />
      </Section>
      <Section topMd={190} topLg={145} topXl={105}>
        <TeamSection
          sectionTitle="Notre équipe"
          sectionTitleUp="RENCONTREZ"
          colClass="col-lg-3 col-md-6"
          data={teamData}
        />
      </Section>
      <Section topMd={170} topLg={120} topXl={80}>
        <GallerySection
          sectionTitle="Nos locaux et <br />l’institut"
          sectionTitleUp="UN APERÇU"
          data={galleryData}
        />
      </Section>
      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <AwardSectionStyle2
          sectionTitle="Notre engagement <br />au quotidien"
          sectionTitleUp="ICVT"
          sectionSubTitle="Prévention, expertise et accueil humain, au cœur du XVIᵉ arrondissement."
          data={awardData}
        />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="images/about/banner_bg_2.jpeg"
          title="Ne laissez pas votre cœur <br />attendre."
          subTitle="Prenez rendez-vous dès aujourd’hui pour un bilan cardiovasculaire personnalisé."
          center
        />
      </Section>
    </>
  );
}
